import immutable from 'immutable';
import { OPERATION_STATUS } from 'util/config/constant';
import {
  ADD_NEW_MACHINE_FAIL,
  ADD_NEW_MACHINE_REQUEST,
  ADD_NEW_MACHINE_SUCCESS,
  CLEAR_CLAIMING_PROCESS_STATE
} from './action';

const initialState = {
  isLoading: false,
  newMachine: null,
  status: OPERATION_STATUS.DEFAULT,
  error: ''
};

const init = () => {
  const initValue = immutable.fromJS({
    claimingProcessInfo: undefined
  });

  return initValue.set('claimingProcessInfo', initialState);
};

export default function claimingProcessReducer(state = init(), action) {
  switch (action.type) {
    case ADD_NEW_MACHINE_REQUEST:
      return state.update('claimingProcessInfo', (cleaningInfo) => ({
        ...cleaningInfo,
        isLoading: true
      }));

    case ADD_NEW_MACHINE_SUCCESS: {
      const {
        payload: { newMachine }
      } = action;
      return state.update('claimingProcessInfo', (cleaningInfo) => ({
        ...cleaningInfo,
        isLoading: false,
        newMachine,
        status: OPERATION_STATUS.SUCCESS
      }));
    }
    case ADD_NEW_MACHINE_FAIL: {
      const {
        payload: { error }
      } = action;
      return state.update('claimingProcessInfo', (cleaningInfo) => ({
        ...cleaningInfo,
        isLoading: false,
        error,
        status: OPERATION_STATUS.FAIL
      }));
    }
    case CLEAR_CLAIMING_PROCESS_STATE:
      return state.update('claimingProcessInfo', () => initialState);
    default:
      return state;
  }
}
